"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyToBufferDynamicContent = exports.copyToBuffer = exports.combineHotelStars = exports.closeFullScreen = void 0;
exports.declension = declension;
var R = _interopRequireWildcard(require("ramda"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var IS_ENABLED_CLIPBOARD_ITEM = Boolean(global.ClipboardItem);
function declension(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2];

  // eslint-disable-next-line max-len
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
}
var closeFullScreen = exports.closeFullScreen = function closeFullScreen() {
  return R.call(R.when(function (doc) {
    return doc.fullscreenElement && doc.exitFullscreen;
  }, function (doc) {
    return doc.exitFullscreen();
  }), global.document);
};
var copyToBufferWithoutClipboardItem = function copyToBufferWithoutClipboardItem(string) {
  return global.navigator.clipboard.writeText(string);
};
var copyToBufferDynamicContentWithoutClipboardItem = function copyToBufferDynamicContentWithoutClipboardItem(getDynamicContent) {
  return getDynamicContent().then(copyToBufferWithoutClipboardItem);
};
var copyToBuffer = exports.copyToBuffer = IS_ENABLED_CLIPBOARD_ITEM ? function (value) {
  return global.navigator.clipboard.write([new global.ClipboardItem({
    'text/plain': new Blob([value], {
      type: 'text/plain'
    })
  })]);
} : copyToBufferWithoutClipboardItem;
var copyToBufferDynamicContent = exports.copyToBufferDynamicContent = IS_ENABLED_CLIPBOARD_ITEM ? function (getDynamicContent) {
  return new Promise(function (resolve, reject) {
    global.navigator.clipboard.write([new global.ClipboardItem({
      'text/plain': getDynamicContent().then(function (content) {
        resolve(content);
        return new Blob([content], {
          type: 'text/plain'
        });
      }).catch(function (error) {
        reject(error);

        // to prevent error with ClipboardItem
        return new Blob([''], {
          type: 'text/plain'
        });
      })
    })]);
  });
} : copyToBufferDynamicContentWithoutClipboardItem;
var combineHotelStars = exports.combineHotelStars = function combineHotelStars(stars, secondaryStars) {
  return global.Number.isFinite(secondaryStars) ? R.concat("".concat(stars, "*"), "/".concat(secondaryStars, "*")) : "".concat(stars, "*");
};